import { Heading } from "native-base";

type Props = {
  title: string;
};

export default function Subsection({ title }: Props) {
  return <Heading size="sm">{title}</Heading>;
}
